import { TabContext } from "@mui/lab";
import React, { useEffect, useState } from "react";
import SnackBar from "../../../component/SnackBar";
import { KlarityChatBotPOST } from "../../../redux/action/ChatBot";
import {
  KlarityFileUpload,
  KlarityFileUploadData,
} from "../../../redux/action/Reports";
import {
  CommonGrid2,
  TabPanelView,
} from "../../common-components/StyledComponents";
import KlarityFileData from "./components/FileData";
import GrowthAgentFileUpload from "./components/FileUpload";
import CommonButton from "../../../component/Button";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";
import AddMoreCandidate from "../../matches/quick-match/components/AddMoreCandidate";
import { CustomDiv } from "../../chat-bot/style";

export default function GrowthAgent() {
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    useState(false);
  const [value, setValue] = useState(0);
  const breadCrumbData = [
    {
      title: "File Upload",
      disabled: true,
    },
    {
      title: "File Data",
      active: true,
    },
  ];
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
  });
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    prevData: "",
  });
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const [klarityData, setKlarityData] = useState({
    data: "",
    loading: false,
    disabled: false,
    data_status: {
      status: "in_progress",
    },
  });

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  // Drag-and-drop functionality
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(droppedFiles, allowedTypes, setFiles, files);
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      const isAllowed = allowedTypes.includes(file.type);

      if (!isAllowed) {
        invalidFiles.push(file.name);
      } else {
        // ✅ Valid file
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          visible: false,
          delete: true,
          message: "",
        });
      }
    });

    if (invalidFiles.length > 0) {
      const message = `❌ Unsupported file types: ${invalidFiles.join(", ")}`;
      setSnackbarState({
        open: true,
        message: message,
        severity: "error",
      });
      return;
    }

    const singleFile = validFiles[0] ? [validFiles[0]] : [];
    setCommonFiles(singleFile);
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  const handleAnalyzeClick = async () => {
    setFiles((prev) =>
      prev.map((item) => ({
        ...item,
        delete: false,
      }))
    );
    setKlarityData((prev) => ({
      ...prev,
      loading: true,
      disabled: true,

      // data_status: {
      //   status: "in_progress",
      // },
    }));
    setChatBotData((prev) => ({
      ...prev,
      message: [
        {
          sender: "bot",
          text: "Hi, I am Hailey. How can I assist you today?",
        },
      ],
      pageLoader: true,
      value: "",
    }));

    const formData = new FormData();
    files.forEach((fileObj, index) => {
      formData.append("file", fileObj.file);
    });

    try {
      let data = await KlarityFileUpload(formData);
      setValue(1);
      setKlarityData((prev) => ({
        ...prev,
        data: data,
        loading: false,
        disabled: false,
        data_status: {
          status: "completed",
        },
      }));
      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
        ],
        value: "",
        pageLoader: false,
      }));
      setAddMoreCandidateDialogOpen(false);
      setFiles([]);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.data?.message,
      });
      setFiles([]);
      setAddMoreCandidateDialogOpen(false);
      setKlarityData((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
        data_status: {
          status: "error_occurred",
        },
      }));
      setErrorDialog((prev) => ({
        ...prev,
        open: true,
      }));
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload = {
      query: chatBotData.value,
    };

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data = await KlarityChatBotPOST(payload);
      const botResponse = {
        sender: "bot",
        text: data?.data?.data?.answer,
        visualizations: data?.data?.data?.visualizations,
        reasoning: data?.data?.data?.reasoning,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleFetchCall = async () => {
    setKlarityData((prev) => ({
      ...prev,
      disabled: true,
      data: {},
    }));
    setChatBotData((prev) => ({
      ...prev,
      message: [
        {
          sender: "bot",
          text: "Hi, I am Hailey. How can I assist you today?",
        },
      ],
      value: "",
    }));
    try {
      const data = await KlarityFileUploadData();
      setKlarityData((prev) => ({
        ...prev,
        data: data?.data?.latest_entry?.response,
        data_status: data?.data?.latest_entry,
        disabled: false,
      }));

      if (data?.data?.latest_entry?.status === "completed") {
        setValue(1);
      } else if (data?.data?.latest_entry?.status === "in_progress") {
        setTimeout(() => {
          handleFetchCall();
        }, 5000);
      }

      if (data?.data?.latest_entry?.response?.error) {
        setErrorDialog((prev) => ({
          ...prev,
          open: true,
        }));
        setFiles([]);
        setSnackbarState({
          open: true,
          message: data?.data?.latest_entry?.response?.error,
          severity: "error",
        });
        setKlarityData((prev) => ({
          ...prev,
          data: data?.data?.previous_active_entry?.response,
          data_status: data?.data?.previous_active_entry,
          disabled: false,
        }));
        setValue(1);
      }
    } catch (error) {
      setKlarityData((prev) => ({
        ...prev,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.data?.message,
        severity: "error",
      });
    }
  };
  useEffect(() => {
    handleFetchCall();
  }, []);

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleUploadNewFile = () => {
    setAddMoreCandidateDialogOpen(true);
  };

  const handleErrorClose = () => {
    setErrorDialog((prev) => ({
      ...prev,
      open: false,
    }));
    setFiles([]);
    setValue(0);
  };

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Close"}
        width={"100%"}
        border={"#D0D5DD"}
        variant="contained"
        color="white"
        background="#D92D20"
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handleErrorClose}
      />
    </CommonGrid2>
  );

  const handleAddMoreCandidateDialogClose = () => {
    setAddMoreCandidateDialogOpen(false);
    setFiles([]);
  };

  return (
    <CustomDiv background="#fff">
      <TabContext value={value}>
        <TabPanelView value={0} padding="0px 0px">
          <GrowthAgentFileUpload
            files={files}
            localStorageData={localStorageData}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            isDragging={isDragging}
            onChange={handleFileUpload}
            handleAnalyzeClick={handleAnalyzeClick}
            klarityData={klarityData}
            handleDeleteFile={handleDeleteFile}
          />
        </TabPanelView>
        <TabPanelView value={1} padding="0px 0px" height="100%">
          <KlarityFileData
            breadCrumbData={breadCrumbData}
            chatBotData={chatBotData}
            handleChatBotChange={handleChatBotChange}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleSendMessage={handleSendMessage}
            klarityData={klarityData}
            handleUploadNewFile={handleUploadNewFile}
          />
        </TabPanelView>

        <SnackBar
          snackbarState={snackbarState}
          handleCloseValidation={handleCloseValidation}
        />

        <DialogCandidateHub
          open={errorDialog.open}
          title="Klarity Insights"
          titlepadding={"0px 0px 16px"}
          handleButttonClose={handleErrorClose}
          footer={<Footer />}
          content={
            "We encountered an unexpected issue while analyzing the uploaded file. Please try again or contact support if the problem persists"
          }
        />

        <AddMoreCandidate
          title={"Add New Growth Agent"}
          addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
          handleAddMoreCandidateDialogClose={handleAddMoreCandidateDialogClose}
          handleAddMoreCandidateDragOver={handleDragOver}
          handleAddMoreCandidateDragLeave={handleDragLeave}
          handleAddMoreCandidateDrop={handleDrop}
          handleAddMoreCandidateFileUpload={handleFileUpload}
          addMoreCandidateFiles={files}
          isAddMoreCandidateDragging={isDragging}
          handleAddMoreCandidateDeleteFile={handleDeleteFile}
          handleAddMoreCandidateClick={handleAnalyzeClick}
          isLoading={klarityData.loading}
          isJem={false}
          // disabled={addMoreCandidateFiles?.length >= 1}
          disabled={klarityData.disabled}
          buttonDisabled={klarityData.loading || files.length === 0}
        />
      </TabContext>
    </CustomDiv>
  );
}
